import { Link } from "react-router-dom/cjs/react-router-dom.min";

function CtaArea() {
  return (
    <section
      style={{
        paddingBottom: "20px",
        position: "relative",
      }}
      className="cta-area cta-bg"
    >
      <div
        style={{
          backgroundColor: "black",
          opacity: 0.5,
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
        }}
      />
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-xl-4 col-lg-6">
            <div
              style={{ zIndex: 1, position: "relative" }}
              className="cta-img"
            >
              <img src="assets/img/images/cta_img.png" alt="" />
            </div>
          </div>
          <div style={{ zIndex: 1, position: "relative" }} className="col-lg-6">
            <div className="cta-content">
              <div className="cta-icon mb-15">
                <img src="assets/img/icon/cta_icon.png" alt="" />
              </div>
              <div className="section-title title-style-three white-title mb-50">
                <h2>
                  WHAT'S <span> NUMBER?</span>
                </h2>
                <p>Handled 2-3 Million sessions every month</p>
              </div>
              <div>
                <Link to="/contact" className="btn btn-style-two">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CtaArea;
